import { Component } from 'react';
import { connect } from 'react-redux';
import api from 'api';
import { breakpoints } from 'styles';
import { LoadingIndicator } from 'components/common';
import { Box } from 'components/common/box';
import { StatItem, StatRow } from 'components/common/stats';

const AnalyticsOverviewUsers = connect((state) => ({
  messages: state.messages,
  theme: state.theme
}))(
  class extends Component {
    state = {
      data: null,
      loading: false
    };

    componentDidMount() {
      this.updateData();
    }

    updateData = async () => {
      try {
        const response = await api.get(`/admin/stats/users`);
        this.setState({ data: response.data.data, loading: false });
      } catch (err) {
        this.setState({ loading: false });
        await this.props.dispatch.handleErrorDispatch(err);
      }
    };

    render() {
      const { messages } = this.props;
      const { data, loading } = this.state;

      return (
        <div className="users">
          {loading ? (
            <LoadingIndicator />
          ) : (
            <>
              <div className="sessions">
                <Box padding={15}>
                  <div className="sessions-content">
                    <StatItem
                      align="left"
                      label={messages.analyticsActiveSessions}
                      labelBefore={true}
                      value={data?.activeSessions}
                    />
                  </div>
                </Box>
              </div>

              <div className="accounts">
                <Box
                  padding={15}
                  style={{ height: 'calc(100% - 20px)', marginTop: 20 }}
                >
                  <div className="accounts-total">
                    <StatItem
                      align="left"
                      label={messages.analyticsUserAccounts}
                      labelBefore={true}
                      value={data?.totalUserCount}
                    />
                  </div>
                  <div className="accounts-detailed">
                    <StatRow
                      label={messages.usersSuperadmins}
                      value={data?.superadminCount}
                    />
                    <StatRow
                      label={messages.usersAdmins}
                      value={data?.adminCount}
                    />
                    <StatRow
                      label={messages.commonUsers}
                      value={data?.userCount}
                    />
                    <StatRow
                      label={messages.usersGuestAccounts}
                      value={data?.guestCount}
                    />
                  </div>
                </Box>
              </div>
            </>
          )}

          <style jsx>{`
            .sessions-content {
              padding: 5px 10px;
            }
            .accounts-total {
              margin-bottom: 10px;
              padding: 10px;
            }
            @media (min-width: ${breakpoints.medium}px) {
              .users {
                display: flex;
                flex-direction: column;
                height: 100%;
              }
              .accounts {
                flex-grow: 1;
              }
            }
          `}</style>
        </div>
      );
    }
  }
);

export default AnalyticsOverviewUsers;
